import type { Option } from '@connected/form-fields/types';

import type { ProjectVersionStatus } from './project-status-types';

export const PROJECT_STATUS_OPTIONS: Option<ProjectVersionStatus>[] = [
    { label: 'Aanvraag', value: 'Request' },
    { label: 'Offerte', value: 'PriceQuote' },
    { label: 'Opdracht', value: 'Order' },
    { label: 'Ingepland', value: 'Planned' },
    { label: 'Afgerond', value: 'Complete' },
    { label: 'Afgekeurd', value: 'Failed' },
    { label: 'Herinspectie', value: 'RepeatInspection' },
];
